import React from 'react';
import SliderEmprendimientos from './slider-emprendimientos';

const SectionEmprendimientos = () => {
	return (
		<>
			<div className='test'>
				<SliderEmprendimientos />
			</div>
		</>
	);
};

export default SectionEmprendimientos;
